<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div v-if="$isSimavet()" class="ten wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/procs/certs/new/form')">
          <i class="plus icon"></i> Novo Laudo
        </button>
      </div>
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic segment no-padding no-margin" :class="{ 'right aligned': $isSimavet() }">
          <div class="ui form">
            <div class="field">
              <search-input id="certs-search-input" ref="searchInput" class="search-input" @onSearch="search" />
              <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
                <i class="filter icon" :class="{ red: !!$store.state.pages.filters.certs }"></i>
              </button>
            </div>
          </div>                        
        </div> 
      </div>      
    </div>

    <data-table id="certs-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="id" :asc="false" @onRowClick="onShowCert" />

    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

  </div>

</template>

<script>
  
  import FilterModal from "./filter"
  import CertService from "@/services/cert-service"
  import SrvService from "@/services/srv-service"
  import gridPage from "@/mixins/grid-page"

  export default {    

    name: "CertsPage",

    mixins: [gridPage],

    data() {
      return {       
        title: "Laudos", 
        service: new CertService(),
        attributes: ["id", "status", "date"],
        fields: [          
          { prop: "id", label: "Número", render: this.renderNumber },
          { prop: "date", label: "Data", render: (cert) => this.$formatDate(cert.date) },
          { prop: "animal.name", model: "Animal", label: "Animal" },
          { prop: "animalRegistration.registrationId", model: "AnimalRegistration", modelAlias: "animalRegistration", label: "Ficha" },          
          { prop: "owner.name", model: "Owner", label: "Tutor" },
          { prop: "customer.shortName", model: "Customer", label: "Clínica" },
          { prop: "service.description", model: "Service", label: "Serviço", render: this.renderService },
          { prop: "user.name", model: "User", label: "Colaborador", render: (cert) => cert.user.name.toUpperCase() },
        ],
      }
    },

    components: {
      FilterModal,
    },

    methods: {

      onShowCert(data) {
        this.$router.push(`/procs/certs/${data.row.id}/show`)
      },

      renderNumber(cert) {

        const statusList = CertService.STATUS

        if (!this.$isSimavet() && cert.status !== "finished")
          cert.status = "maintenance"

        return `<i class="${statusList[cert.status].icon} m-r-10"></i> ${cert.id}`
      },

      renderService(cert) {

        const icon = `<i class="${SrvService.TYPE_ICONS[cert.serviceType.icon].icon} m-r-10"></i>`
        const label = `<div class="ui small label m-l-10">${icon} ${cert.serviceType.description}</div>`

        return cert.service.description + label
      },
    },
  }

</script>
